import ServerWaitButton from 'Shared/components/ServerWaitButton'
import CopyToClipboardBig from 'Shared/components/CopyToClipboardBig'
import './MembershipCardWidget.scoped.scss'

export default function MembershipCardWidget() {
  const act = useAct()
  const {
    membershipCardLink,
    hasInstalledGoogleMembershipCard,
    hasInstalledAppleMembershipCard,
  } = useSel(s => s.target)

  function regenerateGoogleCard() {
    return act.target.regenerateGoogleMembershipCard()
  }

  return (
    <div className="widget">
      <p className="larger bold no-margin-top">Membership Card</p>
      <p>Copy the link below to share this person's digital membership card.</p>

      <div className="card-link-container">
        <CopyToClipboardBig text='Copy' url={membershipCardLink} />
        {hasInstalledGoogleMembershipCard && <ServerWaitButton className='button small primary' onClick={regenerateGoogleCard}>
          Remotely Refresh Google Membership Card
        </ServerWaitButton>}
      </div>

      <div className="install-status">
        <span className={`status-badge ${hasInstalledAppleMembershipCard ? 'status-badge-installed' : ''}`}>
          Apple Wallet - {hasInstalledAppleMembershipCard ? 'Installed' : 'Not installed'}
        </span>
        <span className={`status-badge ${hasInstalledGoogleMembershipCard ? 'status-badge-installed' : ''}`}>
          Google Wallet - {hasInstalledGoogleMembershipCard ? 'Installed' : 'Not installed'}
        </span>
      </div>
    </div>
  )
}
